<template>
  <RevCardCarousel
    :next-alternative-text="i18n(translations.nextSlide)"
    :prev-alternative-text="i18n(translations.previousSlide)"
    size="medium"
  >
    <ProductConditionCard
      v-if="hasPremium"
      :content="i18n(premium.content)"
      :grade="9"
      :imageSrc="getGradeImage(9)"
      :pills="[
        {
          icon: IconSparkles,
          text: i18n(premium.pill1),
        },
        {
          icon: IconOfficialFilled,
          text: i18n(premium.pill2, { brand }),
        },
        {
          icon: IconBattery,
          text: i18n(
            isPremiumDefinitionUpdated
              ? premium.smartphonePill3
              : premium.pill3,
          ),
        },
      ]"
      :title="i18n(premium.grade)"
      :titleIcon="IconDiamond"
    />
    <ProductConditionCard
      :content="i18n(gradeA.content)"
      :grade="10"
      :imageSrc="getGradeImage(10)"
      :pills="[
        {
          icon: IconCheckInCircle,
          text: i18n(gradeA.pill1),
        },
        {
          icon: IconBattery,
          text: i18n(gradeA.pill2),
        },
      ]"
      :title="i18n(gradeA.grade)"
    />
    <ProductConditionCard
      :content="i18n(gradeB.content)"
      :grade="11"
      :imageSrc="getGradeImage(11)"
      :pills="[
        {
          icon: IconCheckInCircle,
          text: i18n(gradeB.pill1),
        },
        {
          icon: IconBattery,
          text: i18n(gradeB.pill2),
        },
      ]"
      :title="i18n(gradeB.grade)"
    />
    <ProductConditionCard
      :content="i18n(gradeC.content)"
      :grade="12"
      :imageSrc="getGradeImage(12)"
      :pills="[
        {
          icon: IconCheckInCircle,
          text: i18n(gradeC.pill1),
        },
        {
          icon: IconBattery,
          text: i18n(gradeC.pill2),
        },
      ]"
      :title="i18n(gradeC.grade)"
    />
  </RevCardCarousel>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { Picker } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCardCarousel } from '@ds/components/CardCarousel'
import { IconBattery } from '@ds/icons/IconBattery'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'
import { IconDiamond } from '@ds/icons/IconDiamond'
import { IconOfficialFilled } from '@ds/icons/IconOfficialFilled'
import { IconSparkles } from '@ds/icons/IconSparkles'

import { getGradeImage as getGradeImageBase } from '../../../../utils/getGradeImage'
import ProductConditionCard from '../ProductConditionCard/ProductConditionCard.vue'

import translations from './ProductConditionBody.translations'
import gradeA from './gradeA.translations'
import gradeB from './gradeB.translations'
import gradeC from './gradeC.translations'
import premium from './premium.translations'

const i18n = useI18n()

const { grades, brand, isPremiumDefinitionUpdated } = defineProps<{
  grades: Picker
  brand: string
  isPremiumDefinitionUpdated?: boolean
}>()

const hasPremium = computed(() =>
  grades.items?.some((item) => item.parameters?.grade.value === 9),
)

function getGradeImage(gradeId: number) {
  return getGradeImageBase(grades, gradeId, 'Body')
}
</script>
